/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/quotes */
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AuditTrailService } from "../audit-trail.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";

export interface ApplicationData {
  autActivity: string;
  autCategory: string;
  autComment: string;
  autIpAddress: string;
  autLogById: string;
  autQuestion: string;
  autReference: string;
  autReferenceId: string;
  autSelfAadharDesc: string;
  autTranasctionDate: string;
  applicationNo: string;
  PAN: string;
  scheme: string;
  pkAutid: string;
}

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class PaymentComponent implements OnInit {
  columnsToDisplay: string[] = ["applicationNo", "PAN", "autTranasctionDate", "autIpAddress", "scheme"];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, "expand"];
  expandedElement: any | null;
  dataSource: MatTableDataSource<ApplicationData>;

  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  @ViewChild(MatSort) sort: MatSort;
  panNo: string = "";
  applications: ApplicationData[] = [];
  tableData: any[] = [];
  regId: string = null;

  ngOnInit() {
    // this.getPaymentInfo();
  }

  constructor(
    private auditTrailService: AuditTrailService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async getPaymentInfo() {
    this.tableData = [];
    let panNumber: any = "0";
    let regId: any = "0";
    if (this.panNo.match(/^\d+$/)) {
      console.log("numeric");
      panNumber = "";
      regId = this.panNo;
    } else {
      console.log("alpha");
      panNumber = this.panNo.toUpperCase();
      regId = "";
    }
    // clear datasource before ws call
    this.dataSource = new MatTableDataSource();
    await this.auditTrailService.getAuditTrail("PAYMENT", panNumber, regId).subscribe((response) => {
      console.log(response);
      if (!response.error) {
        if (response.length > 0) {
          this.tableData = response;
          this.dataSource = new MatTableDataSource<ApplicationData>(response);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          // split key=450&applicationNo=3330000229 into json
          for (let i = 0; i < this.dataSource.data.length; i++) {
            let obj: any = {};
            let arr = this.dataSource.data[i].autReference.split("&");
            for (let j = 0; j < arr.length; j++) {
              let temp = arr[j].split("=");
              if (temp[1] != undefined) {
                obj[temp[0]] = temp[1];
              }
            }
            // add application number to the data source
            this.dataSource.data[i].applicationNo = obj["applicationNo"];
            // add pan number to the data source
            this.dataSource.data[i].PAN = obj["panNumber"];
            // add scheme to the data source
            this.dataSource.data[i].scheme = obj["scheme"];

            this.dataSource.data[i].autReference = obj;

            if(this.regId === null){
              this.regId = obj["registration"];
            }
          }
        } else {
          this.warningToast();
        }
      } else {
        this.errorToast();
      }
    });
  }

  async warningToast() {
    await this._snackBar.open("No data available.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

  async downloadReport() {
    let panNumber: any = "0";
    let regId: any = "0";
    if (this.panNo.match(/^\d+$/)) {
      console.log("numeric");
      panNumber = "";
      regId = this.panNo;
    } else {
      console.log("alpha");
      panNumber = this.panNo.toUpperCase();
      regId = "";
    }

    const progressSpinnerDialog = await this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    await this.auditTrailService
      .exportAuditTrailApplication("PAYMENT", panNumber, regId)
      .subscribe(async (response: any) => {
        console.log(response);
        progressSpinnerDialog.close();
        if (response != "Failure") {
          await this.auditTrailService.downloadFileV1(response.split("/").pop(), this.regId).subscribe((blob: any) => {
            let file = new Blob([blob], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          });
        } else {
          await this._snackBar.open("Unable to download report.", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      });
  }

  buttonDisabled: boolean = true;
  checkInput(inputValue: string): void {
    if (/^[a-zA-Z]/.test(inputValue)) {
      console.log("Input starts with a character");
      const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      if (panRegex.test(inputValue)) {
        console.log("Valid PAN number");
        this.buttonDisabled = false;
      } else {
        console.log("Invalid PAN number");
        this.buttonDisabled = true;
      }
    } else if (/^\d/.test(inputValue)) {
      const numberRegex = /^\d+$/;
      if (numberRegex.test(inputValue)) {
        console.log("Input starts with a number and contains numbers throughout");
        this.buttonDisabled = false;
      } else {
        console.log("Input starts with a number but contains non-numeric characters");
        this.buttonDisabled = true;
      }
    } else {
      console.log("Input does not start with a character or number");
      this.buttonDisabled = true;
    }
  }
}
